module.exports = __webpack_public_path__ + "img/collaboratori-image-2.5a7726f5.png";